import { useState } from "react";
import { Leaf } from "lucide-react";
import { cn } from "@/lib/cn";

// Renders the product render when present; falls back to a branded placeholder tile
// (leaf-green gradient + leaf mark + name) when the image is missing or fails to load.
// Drop the real PNGs into /public/products/ to replace placeholders — no code change needed.
export function ProductImage({
  src,
  alt,
  name,
  className,
  imgClassName,
}: {
  src?: string;
  alt: string;
  name?: string;
  className?: string;
  imgClassName?: string;
}) {
  const [errored, setErrored] = useState(false);
  const showPlaceholder = !src || errored;

  return (
    <div
      className={cn(
        "relative overflow-hidden rounded-card bg-medical-grey",
        className,
      )}
    >
      {showPlaceholder ? (
        <div className="flex h-full w-full flex-col items-center justify-center gap-2 bg-gradient-to-br from-leaf-green/15 via-medical-grey to-healthy-blue/10 p-4 text-center">
          <Leaf
            className="text-leaf-green-ink/70"
            size={40}
            strokeWidth={1.5}
          />
          {name && (
            <span className="font-condensed text-xs font-bold uppercase tracking-wider text-night-blue/70">
              {name}
            </span>
          )}
        </div>
      ) : (
        <img
          src={src}
          alt={alt}
          loading="lazy"
          onError={() => setErrored(true)}
          className={cn("h-full w-full object-contain", imgClassName)}
        />
      )}
    </div>
  );
}
